export const environment = {
  apiHost: '',
  production: false,
  serviceWorkerEnabled: true,
};
